import {dialogBoxConfig} from "./dialogBoxConfig";

const raiseNotImplemented = () => {
    throw new Error('Either a variant was not provided for the Create Edit Dialog box, either it is not implemented yet.');
};

const userListDialogBoxConfig = () => {
    return dialogBoxConfig["userList"] ?? dialogBoxConfig.defValue;
};

const customerUserDialogBoxConfig = () => {
    return dialogBoxConfig["customerUser"] ?? dialogBoxConfig.defValue;
};

export const variantDialogBoxConfigMap = {
    defValue: raiseNotImplemented,
    userList: userListDialogBoxConfig,
    customerUser: customerUserDialogBoxConfig,
};

export const extractSections = (configuration) => {
    const accumulatorStartObject = [];
    const reducingFn = (accumulator, currentConfig) => {
        /**
         * expected something like
         * {
         *     sectionName: "Section 1",
         *     labelProperty: "Property1",
         *     valueProperty: "Property2",
         *     type: "text",
         *     isControlled: true,
         *     options: [...]
         * }
         */
        const sectionName = currentConfig?.sectionName ?? undefined;
        if (sectionName !== undefined && !accumulator.includes(sectionName)) accumulator.push(sectionName);
        return accumulator;
    };

    const finalSectionsList = configuration.reduce(reducingFn, accumulatorStartObject);
    return finalSectionsList;
};